import Loading from '../../components/Loading';
import React from 'react';
import View from '../../components/ChangeEmail';
import changeEmail from '../../actions/changeEmail';
import isAuthenticated from '../../actions/isAuthenticated';
import { IProfileResponse } from '../../model/ProfileResponse';
import { WithTranslation, withTranslation } from 'react-i18next';

export const context = 'changeEmail';

export class Route extends React.PureComponent<WithTranslation> {
    state = {
        data: {},
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        try {
            const res = await isAuthenticated();
            const { data } = res as IProfileResponse;
            this.setState({ data, isLoading: false });
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    render() {
        const { isLoading, data, error } = this.state;

        if (error) {
            throw error;
        }

        if (isLoading) {
            return <Loading />;
        }

        return <View action={changeEmail} context={context} data={data} {...this.props} />;
    }
}

export default withTranslation()(Route);
